/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Heart_heartPortfolioItems = ReadonlyArray<{
    readonly portfolioId: string | null;
    readonly portfolioItemId: string | null;
    readonly " $refType": "Heart_heartPortfolioItems";
}>;
export type Heart_heartPortfolioItems$data = Heart_heartPortfolioItems;
export type Heart_heartPortfolioItems$key = ReadonlyArray<{
    readonly " $data"?: Heart_heartPortfolioItems$data;
    readonly " $fragmentRefs": FragmentRefs<"Heart_heartPortfolioItems">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Heart_heartPortfolioItems",
  "type": "PortfolioItemV2",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "portfolioId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "portfolioItemId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '90ec07cccf758fe32c2edbfb66e9ab69';
export default node;
